import React, {useCallback} from "react";

import { ReactComponent as BellIcon } from "../../../assets/images/notification.svg";
import { ReactComponent as StarIcon } from "../../../assets/images/star.svg";
import { ReactComponent as TentaclesIcon } from "../../../assets/images/headertest-tentacles.svg";
import {formatTimeSinceShort} from "../../../hooks/formatTimeSince";
import useGetEnvironment from "../../../hooks/useGetEnvironment";

type Props = {
	data: {
		timestamp: number,
		content: string,
		title: string,
		type: string,
		relationId: string,
		brandId: string
	}
}

const Notification = (props: Props) => {
	const data = props.data;
	const getEnvironment = useGetEnvironment();
	const environment = getEnvironment();

	const getIcon = () => {
		switch (data.type) {
			case "updates":
				return <BellIcon/>;
			case "star":
				return <StarIcon/>;
			case "tentacles":
				return <TentaclesIcon/>;
			default:
				return ""
		}
	}

	const getIconClass = () => {
		switch (data.type) {
			case "updates":
				return "bell";
			case "acts":
				return "circle";
			case "tentacles":
				return "tentacles";
			default:
				return "";
		}
	};

	const getTime = (timestamp: number) => {
		const date = new Date(timestamp);
		const unixTimestamp = Math.floor(date.getTime());
		return formatTimeSinceShort(unixTimestamp);
	};

	const createUrl = (relationId: string, brandId: string) => {
		let url = "";
		if (environment === "staging" || environment === "staging2") {
			url = `https://${brandId}-${environment}.smartocto.com/#/stream/${relationId}/`
		} else {
			url = `https://${brandId}.smartocto.com/#/stream/${relationId}/`;
		}
		return url
	}

	return (
		<div className="notification-widget__item">
			<div className="notification-widget__item-header">
				<div className={`notification-widget__icon ${getIconClass()}`}>
					{getIcon()}
				</div>
				<div className="notification-widget__time">{getTime(data.timestamp)} ago</div>
			</div>

			<div className="notification-widget__item-title">
				<a href={createUrl(data.relationId, data.brandId)} target="_blank" rel="noreferrer">
					<span>{data.content}</span>
				</a>
			</div>

			<div className="notification-widget__item-subtitle">
				<span>{data.title}</span>
			</div>
		</div>
	);
};

export default Notification;
